import { ConfirmModal } from "@advapacs/common";
import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { BlockerFunction, useBlocker } from "react-router-dom";

interface IBlockRouter {
  blocked?: boolean;
}

export const BlockRouter: FC<IBlockRouter> = ({ blocked }) => {
  const { t } = useTranslation();

  const promptUnload = (event) => {
    event.preventDefault();
    event.returnValue = true;
  };

  useEffect(() => {
    if (blocked) window.addEventListener("beforeunload", promptUnload);

    return () => {
      if (blocked) window.removeEventListener("beforeunload", promptUnload);
    };
  }, [blocked]);

  const shouldBlock = React.useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) =>
      blocked && currentLocation.pathname !== nextLocation.pathname,
    [blocked]
  );
  const blocker = useBlocker(shouldBlock);
  return blocker.state === "blocked" ? (
    <ConfirmModal
      show={blocker.state === "blocked"}
      onClose={() => {
        blocker.reset();
      }}
      body={t("admin:navigate_confirm_modal_message")}
      cancel={() => blocker.reset()}
      confirm={() => blocker.proceed()}
    />
  ) : null;
};
